<template>
    <v-row v-if="!isDemoMode" class="mx-1 my-7">
        <slot name="meta" />

		<v-col v-if="contentData.Title" cols="12">
			<h3 class="q-title text-center">{{ contentData.Title }}</h3>
		</v-col>

		<slot name="DataTables">
        	<div class="columns-wrapper align-stretch justify-center" :style="itemsStyle">
                <div v-for="(datatable, key) in contentData.DataTables" :key="key" class="column-item pa-2">
                    <q-cms-data-table :datatable="datatable" />
                </div>
			</div>
		</slot>
    </v-row>
</template>

<script>
import QCmsDataTable from './Elements/DataTable.vue'
import { CmsGroupViewMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    name: 'DataTableGroup',
	components: {
        QCmsDataTable
    },
	mixins: [CmsGroupViewMixin],
    props: {
        contentData: {
            type: Object,
            default: function() {
                return {
                    DataTables: [{}],
                    Title: '',
                    NumColumns: 1,
                }
            }
        }
    },
}
</script>
